import { useHistory } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import { makeStyles, Typography, Button, Select, MenuItem } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import AddIcon from '@material-ui/icons/Add'
import useSort from '../../../services/um/lookups/useSort'
import { Order, SettingRECListType } from '../../../services/um/useSettingREC'
import isEmpty from 'lodash/isEmpty'
import Item from './Item'
import EmptyData from './EmptyData'

interface ResultProps {
    onSort: (value: any) => void
    order: Order
    dataList: SettingRECListType[]
}

const Result = ({ onSort, order, dataList }: ResultProps) => {
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    const history = useHistory()
    const classes = useStyles()
    const { sorts } = useSort()

    const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
        onSort(event.target.value)
    }

    const GotoAddOfficer = () => {
        history.push('/settingREC/Add')
    }

    return (
        <div className={classes.container}>
            <Grid container justify="space-between" alignItems="center" style={{ margin: '15px 0px' }}>
                <Grid item xs={12} md={6}>
                    <Typography variant="h6">
                        {translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${dataList.length}`])}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container justify="flex-end" spacing={2}>
                        <Grid item>
                            <Button
                                size="large"
                                variant="outlined"
                                color="primary"
                                onClick={GotoAddOfficer}
                                startIcon={<AddIcon />}
                            >
                                <Typography variant="button">{translate.get('UM.SETTING_FACULTY.ADD')}</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <EmptyData isEmpty={isEmpty(dataList)}>
                <Grid item xs={12}>
                    {dataList.map((item) => (
                        <Item
                            key={item.id}
                            id={item.id}
                            nameTH={item.name.th}
                            nameEN={item.name.en}
                            recName={item.rec.name[lang]}
                        />
                    ))}
                </Grid>
            </EmptyData>
        </div>
    )
}

export default Result

const useStyles = makeStyles((theme) => ({
    container: {
        margin: theme.spacing(2, 0),
    },
    typo: {
        fontWeight: 'bold',
    },
    sorting: {
        margin: theme.spacing(2, 0),
    },
}))
